import { NotFoundMessage } from '../../components/NotFoundMessage';

export const NotFoundPage = () => {
   return (
      <>
         <NotFoundMessage />
      </>
   );
};
